import React, { useState } from "react";
import { speakers, moderator } from "../data/mock";
import { Separator } from "./ui/separator";
import { Mic, Award, Shield, Tv, ArrowRight } from "lucide-react";

const speakerIcons = [Award, Tv, Shield];

export const SpeakersSectionBlack = () => {
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <section id="speakers" className="py-[120px]" style={{ background: "#f3f4f6" }}>
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Section Label */}
        <span
          className="inline-block text-[#6b7280] text-xs font-medium uppercase tracking-[0.2em] mb-6"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          The Voices
        </span>

        <h2
          className="text-[#000000] uppercase leading-[0.85] mb-4"
          style={{
            fontFamily: "'Montserrat', Arial, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(2rem, 1.5rem + 2vw, 3rem)",
          }}
        >
          The Speakers
        </h2>
        <p
          className="text-[#1f2937] text-lg font-medium leading-relaxed max-w-2xl mb-16"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          Three accomplished women with powerful stories and real-world credibility.
        </p>

        {/* Speaker Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {speakers.map((speaker, i) => {
            const Icon = speakerIcons[i];
            const isHovered = hoveredIdx === i;
            return (
              <div
                key={i}
                className="group flex flex-col border border-[#e5e7eb] transition-colors duration-150 cursor-pointer"
                style={{ backgroundColor: isHovered ? "#f9fafb" : "transparent" }}
                onMouseEnter={() => setHoveredIdx(i)}
                onMouseLeave={() => setHoveredIdx(null)}
              >
                {/* Image Area */}
                <div className="flex flex-col items-center justify-center min-h-[21rem] relative overflow-hidden">
                  <div
                    className="w-28 h-28 rounded-full flex items-center justify-center border-2 transition-colors duration-300"
                    style={{
                      borderColor: isHovered ? "#000000" : "#e5e7eb",
                      background: isHovered ? "rgba(0,0,0,0.08)" : "rgba(0,0,0,0.06)",
                    }}
                  >
                    <span
                      className="text-3xl text-[#000000]"
                      style={{ fontFamily: "'Montserrat', Arial, sans-serif", fontWeight: 900 }}
                    >
                      {speaker.initial}
                    </span>
                  </div>
                  <div className="absolute top-5 right-5">
                    <Icon size={20} className="text-[#6b7280]" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-8 flex flex-col flex-1 min-h-[14rem]">
                  <h3
                    className="text-[#000000] text-xl uppercase mb-2"
                    style={{ fontFamily: "'Montserrat', Arial, sans-serif", fontWeight: 900, lineHeight: 1.1 }}
                  >
                    {speaker.name}
                  </h3>
                  <p
                    className="text-[#6b7280] text-xs uppercase tracking-[0.15em] font-medium mb-4"
                    style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                  >
                    {speaker.role}
                  </p>
                  <Separator className="bg-[#e5e7eb] mb-4" />
                  <p
                    className="text-[#1f2937] text-sm font-medium leading-relaxed flex-1"
                    style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                  >
                    {speaker.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Moderator */}
        <div className="mt-16 border border-[#e5e7eb] p-8 md:p-12">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-shrink-0">
              <div
                className="w-20 h-20 rounded-full flex items-center justify-center border border-[#e5e7eb]"
                style={{ background: "rgba(0,0,0,0.06)" }}
              >
                <Mic size={28} className="text-[#000000]" />
              </div>
            </div>
            <div className="flex-1">
              <span
                className="inline-block text-[#6b7280] text-xs font-medium uppercase tracking-[0.2em] mb-3"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                Moderator & MC
              </span>
              <h3
                className="text-[#000000] text-2xl md:text-3xl uppercase mb-2"
                style={{ fontFamily: "'Montserrat', Arial, sans-serif", fontWeight: 900, lineHeight: 1.1 }}
              >
                {moderator.name}
              </h3>
              <p
                className="text-[#6b7280] text-xs uppercase tracking-[0.15em] font-medium mb-4"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {moderator.role}
              </p>
              <p
                className="text-[#1f2937] text-base font-medium leading-relaxed max-w-2xl"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {moderator.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
